import { Link } from "react-router-dom";

const PatientCard = ({ patient }) => {
  const id = patient.patient_id || patient.id; // Fallback to id if patient_id is not available
  return (
    <div className="bg-white rounded-lg p-3 cardPaitent shadow-lg hover:shadow-xl transition-shadow duration-300">
      <div className="flex">
        <div className="flex-shrink-0">
          <Link
            to={`/landing/rpm_list/${id}`}
            className="no-underline"
          >
            {patient.imageSrc ? (
              <img
                src={patient.imageSrc}
                alt=""
                className="rounded-full"
                style={{
                  width: "50px",
                  height: "50px",
                }}
              />
            ) : (
              <div
                className="rounded-full text-white flex justify-center items-center"
                style={{
                  width: "50px",
                  height: "50px",
                  fontSize: "24px",
                  backgroundColor: "#3F4A9C",
                }}
              >
                {patient.name[0]}
              </div>
            )}
          </Link>
        </div>
        <div className="flex-grow ml-3">
          <div className="flex justify-between">
            <Link
              to={`/landing/rpm_list/${id}`}
              className="no-underline"
            >
              <h4>{patient.name}</h4>
            </Link>
            <i className="fas fa-ellipsis-h"></i>
          </div>
          <div className="grid grid-cols-3">
            <div className="col-span-2">
              <label>
                Patient No: <span>{id}</span>
              </label>
            </div>
            <div>
              <label>
                Age: <span>{patient.age}</span>
              </label>
            </div>
            <div className="col-span-3">
              <label>
                Phone: <span>{patient.phone}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-12 mt-2">
        <Link
          to={`/landing/rpm_list/${id}`}
          className="text-decoration-none moreDetails"
        >
          See more
        </Link>
      </div>
    </div>
  );
};

export default PatientCard;
